import { useEffect, useState, createContext, useRef, useContext } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { cookie } from 'shared-kernel/helpers';
import { getEndpoint } from "../helper";

import Drawer from "../drawer";
import BottomMenu from "../bottom-menu";
import Loader from "../loader";

import { useNavigationDirection } from "./../nc";

export const LayoutContext = createContext({
    mobile: undefined,
    cartCount: 0,
    setCartCount: () => { },
    setPaperCount: () => { }
});

export default function Layout({ children, title, showBottomMenu, showBasketIcon, showBackIcon, showMenuIcon, searchText, onSearchTextChange, hideHeader, showPaperIcon, showInfoIcon, isBottomMenuPage }) {
    const history = useHistory();
    const location = useLocation();
    const direction = useNavigationDirection();

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [mobile, setMobile] = useState('');
    const [cartCount, setCartCount] = useState(0);
    const [paperCount, setPaperCount] = useState(0);
    const [pageTitle, setPageTitle] = useState(title || '');
    const [brandId, setBrandId] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const controllerRef = useRef(null);

    const updateCartCount = () => {
        let cartId = cookie.get('cid');
        if (cartId) {
            controllerRef.current = new AbortController();
            const signal = controllerRef.current.signal;

            fetch(getEndpoint(`/api/cart/get?cartid=${cartId}`), { signal })
                .then(res => res.json())
                .then(data => {
                    let quantitySum = data.data.reduce((p, c) => p += c.quantity, 0);

                    setCartCount(quantitySum);
                });
        }
    }

    useEffect(() => {
        controllerRef.current = new AbortController();
        const signal = controllerRef.current.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint("/api/android/auth/getcookie"), { credentials: "include", signal });
                if (!response.ok) {
                    history.push('/welcome');
                    return;
                }
                const json = await response.json();
                setMobile(json.mobile);
            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        updateCartCount();

        return () => controllerRef.current.abort();
    }, []);

    useEffect(() => {
        setIsDrawerOpen(false);
        updateCartCount();
    }, [location]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <LayoutContext.Provider value={{ mobile, cartCount, setCartCount, setPaperCount, setPageTitle, setBrandId }}>
            <main className="d-f fd-c" style={{ backgroundColor: '#f5f5f5' }}>
                {!hideHeader && (
                    <header className="d-f ai-c _bc-h px-4 c-w fsh-0 fg-0 p-f t-0 l-0 r-0 zi-60" style={{ height: '5.8rem' }}>
                        {showMenuIcon && <img onClick={() => setIsDrawerOpen(true)} className="c-p" src={getEndpoint("/pwa/img/icons/menu.svg")} />}
                        {showBackIcon && <img className="c-p p-r" src={getEndpoint("/pwa/img/icons/back.svg")} style={{ width: '2.4rem', top: '.1em' }} onClick={e => history.goBack()} />}
                        {onSearchTextChange && (
                            <input
                                type='text'
                                placeholder='جستجو'
                                value={searchText}
                                onChange={(e) => onSearchTextChange(e.target.value)}
                                className='bc-t bbw-2 bbc-w c-w mx-8 p-a r-0 l-0 f:o-n'
                                style={{ padding: '.5em 0' }}
                            />
                        )}
                        <div className="mr-4" style={{ fontSize: '1.6rem' }}>{pageTitle}</div>
                        {showInfoIcon && (
                            <Link className="d-b mr-a p-r" style={{ width: '2.4rem', marginLeft: '3.8rem' }} to={`/brand-file/${brandId}`}>
                                <img className="c-p w-100" src={getEndpoint("/pwa/img/icons/info_w.svg")} />
                            </Link>
                        )}
                        {showBasketIcon && (
                            <Link className={`d-b p-r ${showInfoIcon ? '' : 'mr-a'}`} style={{ width: '2.4rem' }} to='/cart'>
                                <img className="c-p w-100" src={getEndpoint("/pwa/img/icons/basket2.svg")} />
                                {cartCount > 0 && (
                                    <div
                                        className="d-if ai-c jc-c p-a br-50"
                                        style={{ backgroundColor: '#fc0000', width: '1.8rem', height: '1.8rem', fontSize: '.8em', right: '-1em', top: '-.6em' }}
                                        children={cartCount}
                                    />
                                )}
                            </Link>
                        )}
                        {showPaperIcon && (
                            <Link className="d-b mr-a p-r" style={{ width: '2.4rem' }} to='/selected-products'>
                                <img className="c-p w-100" src={getEndpoint("/pwa/img/icons/paper.svg")} />
                                {paperCount > 0 && (
                                    <div
                                        className="d-if ai-c jc-c p-a br-50"
                                        style={{ backgroundColor: '#fc0000', width: '1.8rem', height: '1.8rem', fontSize: '.8em', right: '-1em', top: '-.6em' }}
                                        children={paperCount}
                                    />
                                )}
                            </Link>
                        )}
                    </header>
                )}
                <div className="page-container">
                    {
                        isBottomMenuPage
                            ? (
                                <div style={{
                                    flex: 1,
                                    marginTop: hideHeader ? 0 : '5.8rem',
                                }} children={children} />
                            )
                            : (
                                <TransitionGroup component={null}>
                                    <CSSTransition
                                        key={location.pathname}
                                        timeout={{
                                            enter: 400,
                                            exit: 300
                                        }}
                                        classNames={{
                                            enter: direction === "POP" ? "zoom-in-reverse" : "zoom-in",
                                            enterActive: direction === "POP" ? "zoom-in-reverse-active" : "zoom-in-active",
                                            exit: direction === "POP" ? "zoom-out-reverse" : "zoom-out",
                                            exitActive: direction === "POP" ? "zoom-out-reverse-active" : "zoom-out-active",
                                        }}
                                        mountOnEnter
                                        unmountOnExit
                                    >
                                        <div style={{
                                            width: '100%',
                                            marginTop: hideHeader ? 0 : '5.8rem',
                                            backgroundColor: '#f5f5f5',
                                            height: 'calc(100% - 5.8rem)'
                                        }} children={children} />
                                    </CSSTransition>
                                </TransitionGroup>
                            )
                    }
                </div>

                {showBottomMenu && <BottomMenu />}

                {showMenuIcon && <Drawer open={isDrawerOpen} toggleDrawer={() => setIsDrawerOpen(false)} />}
            </main >
        </LayoutContext.Provider >
    );
}